export default __webpack_public_path__ + "static/media/mexico.0b9713e5.svg";